import { Component, computed, effect, inject, input, output, untracked } from '@angular/core';
import { SystemModulesEnum } from '@models/module/main/systemModules.enum';

import { DocumentDetailsStore } from '@module-instance/dynamic-module/document-details/common';
import { DocumentDetailsTabsComponent } from '@module-instance/dynamic-module/document-details/document-details-tabs/document-details-tabs.component';
import { NotificationService } from '@shared/services';
import { DialogClosed, UserStore } from '@signal-store/index';
import { ProgressPaymentInfoModel } from './common';

@Component({
  selector: 'cipo-progress-payment',
  template: '<cipo-document-details-tabs [entityInstanceId]="this.entityInstanceId()" />',
  imports: [DocumentDetailsTabsComponent],
  providers: [DocumentDetailsStore],
})
/** Component used for angularJS progress payment. Only contains the tabs, and should be deleted after migration */
export class ProgressPaymentComponent {
  // This will be the main progress payment page component
  // For now, it only displays the tabs

  private userStore = inject(UserStore);
  private notify = inject(NotificationService);
  private dmStore = inject(DocumentDetailsStore);

  entityInstanceId = input.required<number>({ alias: 'entityinstanceid' });
  reloadActivity = input<boolean>(false, { alias: 'reloadactivity' });
  selectedPeriodId = input<number>(undefined, { alias: 'selectedperiodid' });
  sovEntityInstanceId = input<number>(undefined, { alias: 'soventityinstanceid' });
  moduleTypeId = input<number>(undefined, { alias: 'moduletypeid' });
  reload = output<void>();

  currentDocument = computed(() => this.dmStore.documents()[this.entityInstanceId()]);
  generalInfo = computed(() => this.currentDocument()?.info as ProgressPaymentInfoModel);
  loadingRollback = computed(() => this.currentDocument()?.loadingRollback);

  constructor() {
    effect(() => {
      if (this.loadingRollback() === 'success') {
        this.notify.success('messages.lastActionUndone');
        this.reload.emit();
      }
    });

    effect(() => {
      const dialogData = this.userStore.dialogData();
      switch (dialogData) {
        case DialogClosed.DmAssignmentChanged:
        case DialogClosed.EmailSent:
          const params = untracked(() => this.currentDocument()?.params);
          this.dmStore.loadActivityInstances(params);
      }
    });

    effect(() => {
      if (this.reloadActivity()) {
        const params = untracked(() => this.currentDocument()?.params);
        this.dmStore.loadActivityInstances(params);
      }
    });
  }

  ngOnInit() {
    const params = {
      moduleId: SystemModulesEnum.ProgressPayment,
      entityInstanceId: this.entityInstanceId(),
      contractId: this.userStore.contract()?.id || 0,
      paymentPeriodId: this.selectedPeriodId(),
      sovEntityInstanceId: this.sovEntityInstanceId(),
      moduleTypeId: this.moduleTypeId(),
      workflowId: undefined,
      screenId: undefined,
    };
    this.dmStore.setDocumentParams(params);
    this.dmStore.loadGeneralInformation(params);
  }
}
